const initialState = {
  jobs: []
}

export default (state = initialState, { type, payload }) => {
  switch (type) {

  case "updateCronjobList":
    return { ...state, ...payload }

  default:
    return state
  }
}
